import React, { useState, useEffect } from 'react'
import { Select } from 'antd';
import { observer } from 'mobx-react-lite';
import { transformListForSelect } from '@/utils/list';
import { serieNavMenu, seriesNavMenuRight } from '@/constants/serials'
import { storeUser } from '@/store/user';

import api from '@/api/index'

import CardContent from "@/components/card/CardContent";

import './styles/block-serial-info.scss'

interface Props {
    serialId: number | string;
    defaultValue: number | string;
    activeNavItem?: string;

    update(seasonId: number | string);
    updateNav(key:string)
}

const BlockSerialInfo = observer(({serialId, defaultValue, activeNavItem, update, updateNav}: Props) => {
    const [seasons, setSeasons] = useState([])
    const [season, setSeason] = useState(defaultValue ? defaultValue : null)

    const fetchSeasons = async() => {
        const response = await api.seasons.getFromSerial(serialId)
        const list = transformListForSelect(response?.data?.data?.seasons || [], 'title', 'id')
        setSeasons(list);
    }

    const handleUpdateNav = (item:any) => {
      if(!season) {
        return
      }

      updateNav(item.key)
    }

    const menuItemClassNames = (item) => {
      let baseClasses = `app-btn`;
      let activeClasses = '';

      if(!season) {
        baseClasses += ' disabled';
      }

      if(item.key === activeNavItem) {
        activeClasses = ' active'
      }
      
      return `${baseClasses} ${activeClasses}`
    }

    useEffect(() => {
      fetchSeasons()
    }, [serialId])

    const filteredNavMenu = storeUser.isSuperAdmin
      ? serieNavMenu
      : serieNavMenu.filter(item => item.key !== 'voiceover-order');

    return (
        <CardContent isPaddingTop={true}>
          <div className={"form-group"}>
            <label className={"form-group-label"}>Сезон</label>
            <Select
              className={"app-select"}
              value={season}
              onChange={(val) => {
                setSeason(val)
                update(val)
              }}
              placeholder="Выберите сезон"
              options={seasons}
              allowClear
            />
          </div>

            <div className={'block-serial-info__navs'}>
                <nav className="block-serial-info__links block-serial-info__links--btns block-serial-info__links--left">
                    {
                        filteredNavMenu.map((item) => {
                            return (
                                <a key={item.key}
                                   className={menuItemClassNames(item)}
                                   onClick={() => handleUpdateNav(item)}
                                >
                                    { item.name }
                                </a>
                            )
                        })
                    }
                </nav>

                <nav className="block-serial-info__links block-serial-info__links--btns">
                    {
                        seriesNavMenuRight.map((item) => {
                            return (
                                <a key={item.key}
                                   className={menuItemClassNames(item)}
                                   onClick={() => handleUpdateNav(item)}
                                >
                                    { item.name }
                                </a>
                            )
                        })
                    }
                </nav>
            </div>
        </CardContent>
    )
});

export default BlockSerialInfo